module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block, _vm.getBlockModifiers(), {
      'bm-active': _vm.active == _vm.index,
      'bm-iconLeft': _vm.iconLeft
    }],
    style: ({
      height: _vm.contentHeight + 'px'
    })
  }, [_c('div', {
    class: [_vm.block] + '-header',
    style: ({
      height: _vm.defaultHeight + 'px'
    }),
    on: {
      "click": function($event) {
        _vm.changeExpandable(_vm.index)
      }
    }
  }, [_c('div', {
    class: [_vm.block + '-icon', {
      'm-rotate45': (_vm.rotate45 && _vm.active == _vm.index),
      'm-rotate': (_vm.active == _vm.index && !_vm.rotate45)
    }]
  }, [_c('icon-gb', {
    attrs: {
      "name": 'spotin-com-' + _vm.icon,
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-headerText'
  }, [_vm._v(_vm._s(_vm.data.header))]), _vm._v(" "), _vm._l((_vm.data.columns), function(column, index) {
    return (_vm.data.columns) ? _c('div', {
      class: (_vm.block + "-column " + _vm.block + "-column" + index)
    }, [(column) ? _c('icon-gb', {
      class: [_vm.block] + '-checkmark',
      attrs: {
        "name": "spotin-com-24px_Checkmark_circle_filled",
        "size": "largest"
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-content'
  }, [(_vm.data.content) ? _c('span', {
    class: [_vm.block] + '-contentText',
    domProps: {
      "innerHTML": _vm._s(_vm.data.content)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.columns), function(column, index) {
    return (_vm.data.columns) ? _c('div', {
      class: (_vm.block + "-column " + _vm.block + "-column" + index)
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.components), function(component, index) {
    return (_vm.data.components) ? _c('div', [_c(_vm.data.components[index].type, {
      tag: "component",
      attrs: {
        "data": _vm.data.components[index].data
      }
    })], 1) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2c1db2","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/ColumnedExpandable.vue
// module id = 415
// module chunks = 0